export type TipoEstruturaVeicular = 'monobloco' | 'chassi' | 'estruturaEspacial'

export interface TipoEstruturaDidatica {
  id: TipoEstruturaVeicular
  nome: string
  construcao: string
  leituraImpacto: string
  implicacaoOperacional: string
}

export const TIPOS_ESTRUTURA_VEICULAR: readonly TipoEstruturaDidatica[] = [
  {
    id: 'monobloco',
    nome: 'Monobloco',
    construcao: 'Carroceria e estrutura resistente trabalham como um único conjunto soldado.',
    leituraImpacto: 'Zonas de deformação conduzem e dissipam parte da energia enquanto a célula protege o habitáculo.',
    implicacaoOperacional: 'Identifique caminhos de carga, reforços e várias camadas antes de criar espaço.',
  },
  {
    id: 'chassi',
    nome: 'Chassi separado',
    construcao: 'A carroceria é montada sobre um quadro estrutural independente, frequentemente semelhante a uma escada.',
    leituraImpacto: 'A aula destaca a menor plasticidade do quadro e a possibilidade de maior transmissão de energia aos ocupantes.',
    implicacaoOperacional: 'O quadro rígido altera pontos de apoio, estabilização e comportamento durante afastamentos.',
  },
  {
    id: 'estruturaEspacial',
    nome: 'Estrutura espacial',
    construcao: 'Uma rede de elementos resistentes forma uma célula leve e rígida ao redor do habitáculo.',
    leituraImpacto: 'As cargas percorrem vários elementos interligados; a distribuição depende do projeto específico.',
    implicacaoOperacional: 'A geometria e os materiais podem limitar pontos convencionais de corte ou expansão.',
  },
]

export function tipoEstruturaPorId(id: TipoEstruturaVeicular): TipoEstruturaDidatica {
  return TIPOS_ESTRUTURA_VEICULAR.find((tipo) => tipo.id === id) ?? TIPOS_ESTRUTURA_VEICULAR[0]!
}
